import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

import Color from "@tool/color";
import { GoLeftIcon } from "@/styled/icon";
import { isEmpty, reverse, round } from "lodash";
import defalut from "@static/image/default-bg.png";
import moDemand from "../../../store";
import moIndustry from "../../../store/industry";
import moIndex from "@/page/index/store";

interface IProps {}
interface IState {}

const IndustryHot = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isMock } = moIndex;
  const { hotIndustryList, totalHotIndustryList } = moIndustry;
  const [width, setWidth] = useState(0);
  const getMax = useMemo(() => {
    let max: any = 0;
    if (!isEmpty(hotIndustryList)) {
      hotIndustryList.forEach((item: any) => {
        if (item.amount_rank > max) {
          max = item.amount_rank;
        }
      });
    }
    return max;
  }, [hotIndustryList]);

  const getWidth = () => {
    const id: any = document.getElementById("contents");
    let width = 0;
    if (id && !isEmpty(hotIndustryList)) {
      if (hotIndustryList.length * 85 - (id.clientWidth - 410) > 85) {
        width = hotIndustryList.length * 85;
      } else {
        width = id.clientWidth - 410;
      }
    }
    setWidth(width);
  };

  useEffect(() => {
    getWidth();
    window.addEventListener("resize", getWidth);
    return () => {
      window.removeEventListener("resize", getWidth);
    };
  }, [hotIndustryList]);

  return (
    <section className="industry-hot-warp-over">
      <section
        className="industry-hot-warp"
        style={{
          backgroundImage: isMock
            ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
            : "",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      >
        <p className="pic-title">
          <span>{totalHotIndustryList?.amount_rank?.toLocaleString()}</span>{" "}
          全行业招聘量热度
        </p>
        <section
          className="industry-hot-content"
          style={{ width: `${width}px` }}
        >
          {hotIndustryList?.map((res: any, r: any) => {
            return (
              <section className="output-item" key={`${r}`}>
                <section
                  className="tooptip"
                  style={{
                    left: r >= hotIndustryList.length - 2 ? "-150px" : 0,
                  }}
                >
                  <p>{res.industry}</p>
                  <p>
                    <span>
                      <i style={{ background: Color.primary }}></i>
                      <b>招聘量热度：</b>
                    </span>
                    <strong>{res.amount_rank.toLocaleString()}</strong>
                  </p>
                  <p>
                    <span>
                      <i style={{ background: Color.secondary }}></i>
                      <b>招聘热度变化：</b>
                    </span>
                    <strong>{res.amount_rank_change.toLocaleString()}</strong>
                  </p>
                </section>
                <section className="show-bar">
                  <section className="show-number">
                    <i
                      style={{
                        color:
                          res.amount_rank >= 0
                            ? Color.secondary
                            : Color.success,
                      }}
                    >
                      {res?.amount_rank?.toLocaleString()}
                    </i>
                    {res.amount_rank >= 0 && (
                      <b
                        style={{
                          height: `${
                            (Math.abs(res.amount_rank) * 100) / getMax
                          }%`,
                        }}
                      />
                    )}
                  </section>
                  <section
                    className="picwarps"
                    style={{
                      backgroundColor:
                        res.amount_rank >= 0 ? Color.f76b : Color.c389,
                    }}
                  >
                    {/* <span
                    style={{
                      backgroundImage: `url(${res.industry_icon || defalut})`,
                    }}
                  /> */}
                  </section>
                </section>
                <span className="company">{res.industry}</span>
                <section className="show-rate">
                  <span
                    style={{
                      color:
                        res.amount_rank_change > 0 ? Color.red : Color.success,
                    }}
                  >
                    {res?.amount_rank_change?.toLocaleString()}
                  </span>
                  {res.amount_rank_change > 0 ? (
                    <span className="up">
                      <GoLeftIcon color={Color.red} />
                    </span>
                  ) : (
                    <span className="down">
                      <GoLeftIcon color={Color.success} />
                    </span>
                  )}
                </section>
              </section>
            );
          })}
        </section>
      </section>
    </section>
  );
};

export default observer(IndustryHot);
